import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/user/home/home";
import AllProducts from "./pages/user/allProducts/allProducts";
import SingleProduct from "./pages/user/singleProduct/singleProduct";
import Cart from "./pages/user/cart/cart";
import CustomizedCake from "./pages/user/customizedCake/customizedCake";

const routes = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Home />}></Route>
      <Route exact path="/products" element={<AllProducts />}></Route>
      <Route
        exact
        path="/products/:productID"
        element={<SingleProduct />}
      ></Route>
      <Route exact path="/cart" element={<Cart />}></Route>
      <Route exact path="/custom-cake" element={<CustomizedCake />}></Route>
      {/* <Route exact path="/login" element={<Login />}></Route>
      /* <Route exact path="/register" element={<Register />}></Route>
      
      <Route exact path="/profile" element={<Profile />}></Route>
      <Route exact path="/track" element={<TrackOrder />}></Route>



      <Route exact path="/contact" element={<Contact />}></Route>
      <Route exact path="/refund-policy" element={<RefundPolicy />}></Route>
      <Route exact path="/return-policy" element={<ReturnPolicy />}></Route>
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />}></Route>
      <Route exact path="/faq" element={<FAQ />}></Route> */}
    </Routes>
  );
};

export default routes;
